<template>
  <div :class="{'online': instance && cloudstreamer_ready}" v-if="is_visible" class="elevation-1">
 
    <div style="min-height: 40px; display: grid; grid-template-columns: 40px 1fr; grid-gap: 10px; padding: 5px;">
      <div>
        <template v-if="is_cloudstreamer && !instance">
          <k-btn size="xs" color="success" v-on:click.stop="start_cloudstreamer" :disabled="!can_start()">
            <k-icon>power_settings_new</k-icon>
          </k-btn>
        </template>
        <template v-if="is_cloudstreamer && instance">
          <k-btn size="xs" color="danger" v-on:click.stop="stop_cloudstreamer" :disabled="!can_start()">
            <template v-if="!cloudstreamer_ready">
              <k-progress-circular :value="20" :indeterminate="true" size="24" style="display: flex;"></k-progress-circular>
            </template>
            <template v-else>
              <k-icon>power_settings_new</k-icon>
           </template>
          </k-btn>
        </template>
      </div>
      <div style="line-height: 40px;">
        <div>{{channel_title}}</div>
      </div>
    </div>


    <div>
        <template v-if="is_cloudstreamer && instance && cloudstreamer_ready && https_port">
          <template v-if="view_options">
            <template v-for="view in view_options">
              <k-btn v-if="is_access(view.accepted_production_user_levels || ['director'])" :key="view.name" color="blue" v-on:click="open_cloudstreamer_path(view.path)">{{view.title}}</k-btn>
            </template>
          </template>

          <template v-else>
            <k-btn size="m" v-if="is_access(['director'])" v-on:click="open_gui()">GUI</k-btn>
            <k-btn size="m" v-if="is_access(['director','commentator'])" v-on:click="open_view('webrtc-ext1')">Commentator 1</k-btn>
            <k-btn size="m" v-if="is_access(['director','commentator'])" v-on:click="open_view('webrtc-ext2')">Commentator 2</k-btn>
            <k-btn size="m" v-if="is_access(['director','intercom','commentator'])" color="blue" v-on:click="open_intercom('intercom')">Intercom</k-btn>

            <template v-for="output in webrtc_outputs">
              <k-btn size="m" v-if="is_access(['director','producer'])" v-on:click="open_webrtc(output, false)">{{output.title}}</k-btn>
            </template>
          </template>

        </template>
        <template v-if="is_output && instance">
          <template v-for="output in webrtc_outputs">
            <k-btn size="m" v-on:click="open_webrtc(output, true)">{{output.title}}</k-btn>
          </template>
        </template>
    </div>
  </div>
</template>

<script>
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

import webrtc from '@/lib/webrtc_reader.js'

export default {
  props: ["channel_id", "channel"],

  data () {
//    var ch = this.$cloudserver.channel("channels:"+this.channel_id);
    return {
//      ws_channel: ch,
//      channel: ch.data,
      timestamp: undefined,
      updater: undefined,
      instance: undefined,
      cloudstreamer_ready: false,
      channel_title: "",
      instance_title: "",
      is_cloudstreamer: false,
      is_output: false,
      cloudstreamer_starting: false,
      video_open: false,
      video_name: undefined,
      webrtc_reader: undefined,
      https_port: undefined,
      view_options: undefined,
      view_options_timer: undefined,
    }
  },
  watch: {
/*    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channel = newVal;
        }
      },
      deep: true
    }, */
    cloudstreamer_ready: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.update_view_options_timer();
      }
    }
  },
  mounted () {
//    this.ws_channel.join();
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();

    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);
  },
  beforeDestroy () {
    if (typeof(this.updater) != "undefined") {
      clearTimeout(this.updater);
    }
    if (this.view_options_timer) {
      clearTimeout(this.view_options_timer);
    }
    this.view_options_timer = null;
  },
  methods: {
    is_ios() {
      return (/iPad|iPhone|iPod/.test(navigator.platform) ||(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream
    },
    can_start() {
      return this.is_access(["director"]);
    },
    open_webrtc(output, is_control) {
      this.open_window("#/productions/" + this.channel_id + "/view/" + output.name + "?view=popup&control=" + is_control, "webrtc-" + this.channel_id + "-" + output.webrtc_name, "width=1280, height=720");
    },
    is_access(role) {
      if (this.$is_admin()) return true;
      if (Array.isArray(role)) {
        var ret = false;
        _.each(role, (r) => {
          if (this.is_access(r) == true) ret = true;
        })
        return ret;
      }
      var self = this;
      var groups = this.$store.getters.groups;
      var account = this.$store.state.account;
      if (typeof(account) == "undefined") return false;
      if (typeof(groups) == "undefined") return false;

      var channel_uuid = self.channel.uuid;
      var ret = false;
      _.each(groups, (group) => {
        var channels = group.channels;
        if (channels.includes(channel_uuid)) {
          var production_role = _.get(group, ["meta", "production_roles", account.id]);
          if (role == production_role) ret = true;
        }
      });
      return ret;
    },
    timestamp_update() {
      this.instance = ChannelModel.instance(this.channel);
      this.channel_title = ChannelModel.title(this.channel);
      this.instance_title = InstanceModel.title(this.instance);
      this.is_cloudstreamer = ChannelModel.is_cloudstreamer(this.channel);
      this.https_port = _.get(this.channel, ["configuration", "streamer","config","proxy_port"]) || 
        _.get(this.channel, ["configuration", "streamer", "config", "https_port"]) || 
        _.get(this.instance, ["meta", "https_port"]) || "8070";

      this.is_output = (ChannelModel.get_type(this.channel) == "output");
      this.webrtc_outputs = _.get(this.channel, ["configuration", "streamer", "config", "webrtc_outputs"]);

      if (ChannelModel.is_cloudstreamer(this.channel) && this.instance && this.instance.system_info?.ip && this.cloudstreamer_ready == false) {
        this.check_cloudstreamer();
      }
    },
    open_window(url, name, opts) {
      if (this.is_ios()) {
        document.location.href = url;
      } else {
        window.open(url, name, opts);
      }
    },
    open_gui() {
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url, "new-window-gui", "width=1920, height=1080");
      }
    },
    open_view(type) {
      var mod_name = "output0";
      var view = "webrtc-view";
      if (type == "pgm") {
        mod_name = "output0";
      }
      if (type == "preview") {
        mod_name = "output1";
      }
      if (type == "multiview") {
        mod_name = "output2";
      }
      if (type == "webrtc-ext1") {
        view = "index";
        mod_name = "webrtc-ext1";
      }
      if (type == "webrtc-ext2") {
        view = "index";
        mod_name = "webrtc-ext2";
      }
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url + "m/"+mod_name+"/"+view+".html", "new-window-"+mod_name, "width=1920, height=1080");
      }
    },
    open_cloudstreamer_path(path) {
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url + path, "new-window-cloudstreamer", "width=1920, height=1080");
      }
    },
    open_intercom(role) {
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url + "modules/intercom/users.html?role="+role, "new-window-intercom", "width=1000, height=1080");
      }
    },
    start_cloudstreamer () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "input") {
        if (self.cloudstreamer_starting == true) return;
        self.cloudstreamer_starting = true;
        ChannelModel.start_transcoder(ch, (msg) => {
          self.$message.success("Streamer started!");
          self.cloudstreamer_starting = true;
          self.timestamp_update();
        }, (err) => {
          self.cloudstreamer_starting = false;
          self.$message.success("Streamer start failed!" + JSON.stringify(msg));
          self.timestamp_update();
        });
      }
    },
    stop_cloudstreamer () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "input") {
        var instance = ChannelModel.instance(this.channel);
        InstanceModel.stop_transcoder(instance, (msg) => {
          self.$message.success("Streamer stopped");
          self.cloudstreamer_starting = false;
          self.cloudstreamer_ready = false;
          self.timestamp_update();
        }, (err) => {
          this.cloudstreamer_ready = false;
          self.$message.success("Streamer stop failed!" + JSON.stringify(err));
          self.timestamp_update();
        });
      }
    },
    check_cloudstreamer () {
      var self = this;
      if (this.instance && this.instance.system_info.ip) {
        console.log("Checking cloudstreamer ready");
        var gui_url = InstanceModel.studio_url(this.instance, this.https_port);
        if (gui_url != "") {
          self.$http.get(gui_url + "static/test.html").then((response) => {
            self.cloudstreamer_ready = true;
          }).catch((err) => {
            console.log("Error response ",err);
          });
        }
      }
    },
    get_view_options () {
      const gui_url = InstanceModel.studio_url(this.instance, this.https_port);

      this.$http.get(gui_url + "view_options").then((response) => {
        this.view_options = (response.data || {}).views;
        console.log("View options fetched", this.view_options);
      }).catch((err) => {
        console.log("Error fetching view options", err);
      });
    },
    update_view_options_timer () {
      if (this.view_options_timer) clearTimeout(this.view_options_timer);
      this.view_options_timer = null;

      if (!this.cloudstreamer_ready) return;

      this.view_options_timer = setTimeout(() => {
        this.get_view_options();
      }, 60000);

      this.get_view_options();
    },
  },
  computed: {
    is_visible() {
      if (ChannelModel.is_cloudstreamer(this.channel)) return true;
      if (ChannelModel.get_type(this.channel) == "output" && ChannelModel.is_transcoder(this.channel) == false) {
        if (_.get(this.channel, ["configuration", "streamer", "config", "webrtc_outputs"])) return true;
      }
      return false;
    }
  }
}
</script>

<style scoped>
  .online {
    background-color: var(--ks-background-color-light)
  }
</style>